/**
 * True when a trait value is meaningful to write onto the Amplitude user profile.
 *
 * Profile user properties feed Amplitude Experiment targeting — evaluation *reads* the profile, and only
 * events (e.g. `$identify`) *write* it — so overwriting a property with a blank value (`email: ''`)
 * clobbers it and silently breaks any property-targeted flag until a later non-empty identify. Reject
 * empty / whitespace-only strings and non-finite numbers; keep valid strings and legitimately falsy
 * values (`0`, `false`).
 */
export function isMeaningfulTraitValue(value: unknown): value is string | number | boolean {
  if (typeof value === 'string') {
    return value.trim().length > 0;
  }
  if (typeof value === 'number') {
    return Number.isFinite(value);
  }
  return typeof value === 'boolean';
}
